/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWarning32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M13.912 8.417a.75.75 0 01.75-.75h2.676a.75.75 0 01.75.75v8.475c0 .08-.013.16-.038.237l-.446 1.339a.75.75 0 01-.712.512h-1.784a.75.75 0 01-.712-.512l-.446-1.339a.75.75 0 01-.038-.237V8.417zm1.5.75v7.603l.236.71h.704l.236-.71V9.167h-1.176zM16 20.157a2.088 2.088 0 100 4.176 2.088 2.088 0 000-4.176zm-.588 2.088a.588.588 0 111.176 0 .588.588 0 01-1.176 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M15.47 1.328a.75.75 0 011.06 0L30.672 15.47a.75.75 0 010 1.06L16.53 30.672a.75.75 0 01-1.06 0L1.328 16.53a.75.75 0 010-1.06L15.47 1.328zm.53 1.59L2.919 16 16 29.081 29.081 16 16 2.919z'
      />
    </svg>
  );
}

export default SvgWarning32;
